// extracted by mini-css-extract-plugin
export default {"modalZ":"100001","headerHeight":"80px","currencyButton":"iFIkL","shader":"RdTZ0","outlined":"sn2h4","desktop":"ZcE3G","currencySelect":"p5vye"};